import {CollapseAnimated} from 'components/CollapseAnimated';
import {useIsScrollBottom} from 'core/hooks/useIsScrollBottom';
import {TPropsWithChildrenRequire, TPropsWithClassName} from 'core/types';
import React, {FC} from 'react';

interface IProps extends TPropsWithChildrenRequire, TPropsWithClassName {
    isHidden?: boolean;
    onCollapsed?: (state: boolean) => void;
}
export const CollapseAnimatedOnScrollBottom: FC<IProps> = ({children, isHidden = false, className}) => {
    const isScrollBottom = useIsScrollBottom();

    return (
        <CollapseAnimated className={className} isHidden={isScrollBottom || isHidden}>
            {children}
        </CollapseAnimated>
    );
};
